module.exports = __webpack_public_path__ + "img/a6381556aaa6fb799fb55b87954d5bc8.png";